import {Component, OnDestroy, OnInit, inject} from '@angular/core';
import {Router, RouterLink, RouterOutlet} from '@angular/router';
import {TabBarService} from '../_services/gui/tab-bar.service';
import {GuiPermissionsService} from '../_services/gui/gui-permissions.service';
import {SidenavComponent} from '../sidenav/sidenav.component';
import {CardComponent} from '../sidenav/card/card.component';
import {NgClass} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    imports: [SidenavComponent, CardComponent, RouterLink, NgClass, RouterOutlet, TranslateModule]
})
export class AdminComponent implements OnInit, OnDestroy {

  displaySideCard: boolean = false;

  private router = inject(Router);
  private tabBarService = inject(TabBarService);
  private guiPermissionsService = inject(GuiPermissionsService);

  constructor() {
    this.guiPermissionsService.canViewAdminSideCards$.subscribe(b => this.displaySideCard = b);
  }

  ngOnInit() {
    this.tabBarService.show('admin');
  }

  ngOnDestroy(): void {
    this.tabBarService.hide();
  }

  isActive(urlToMatch: string) {
    return this.router.isActive(urlToMatch, false);
  }

}
